<template>
  <div class="innerBody">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>打卡审核</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="pageparm" class="user-search">
      <el-form-item label="搜索：">
        <el-select
          size="small"
          v-model="pageparm.status"
          placeholder="请选择审核状态"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="search"
          >搜索</el-button
        >
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="taskId" label="打卡任务ID"> </el-table-column>
      <el-table-column prop="taskTitle" label="打卡任务名称"> </el-table-column>
      <el-table-column label="用户头像" width="88" align="center">
        <template slot-scope="scope">
          <img
            v-if="avatarUrl(scope.row.user)"
            :src="avatarUrl(scope.row.user)"
            alt=""
            style="width: 48px; height: 48px; border-radius: 50%; object-fit: cover"
          />
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="小红书账号" min-width="120">
        <template slot-scope="scope">
          {{ xhsAccount(scope.row.user) }}
        </template>
      </el-table-column>
      <el-table-column label="小红书昵称" min-width="120">
        <template slot-scope="scope">
          {{ xhsName(scope.row.user) }}
        </template>
      </el-table-column>

      <el-table-column prop="imageUrl" label="打卡图片">
        <template slot-scope="scope">
          <img
            :src="$store.state.fileBaseUrl + scope.row.imageUrl"
            alt=""
            style="width: 100px; height: 100px"
          />
        </template>
      </el-table-column>

      <el-table-column prop="content" label="打卡文本"> </el-table-column>

      <el-table-column prop="status" label="当前状态">
        <template slot-scope="scope">
          <div>
            <el-tag type="warning" v-show="scope.row.status == 0"
              >待审核</el-tag
            >
            <el-tag type="success" v-show="scope.row.status == 1">已通过</el-tag>
            <el-tag type="danger" v-show="scope.row.status == 2"
              >已驳回</el-tag
            >
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="打卡时间"> </el-table-column>

      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            v-show="scope.row.status == 0"
            >审核</el-button
          >
        
         <el-button
            type="primary"
            size="mini"
            @click="handleDetail(scope.$index, scope.row)"
            v-show="scope.row.status != 0"
            >查看详情</el-button
          >
          
          <!-- 
          <el-button
            size="mini"
            type="danger"
            @click="takenOff(scope.$index, scope.row)"

            v-show="scope.row.onSale == 1"
            >下架</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="takenOn(scope.$index, scope.row)"
             v-show="scope.row.onSale == 0"
            >上架</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <div class="pagtion">
      <Pagination
        v-bind:child-msg="pageparm"
        @callFather="callFather"
      ></Pagination>
    </div>

    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="40%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="打卡任务(ID)" prop="taskId">
          {{ editForm.taskTitle }} ({{ editForm.taskId }})
        </el-form-item>

        <el-form-item label="用户头像">
          <img
            v-if="avatarUrl(editForm.user)"
            :src="avatarUrl(editForm.user)"
            alt=""
            style="width: 80px; height: 80px; border-radius: 50%; object-fit: cover"
          />
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="小红书账号">
          {{ xhsAccount(editForm.user) }}
        </el-form-item>
        <el-form-item label="小红书昵称">
          {{ xhsName(editForm.user) }}
        </el-form-item>

        <el-form-item label="打卡文本" prop="content">
          {{ editForm.content }}
        </el-form-item>

        <el-form-item label="打卡图片" prop="imageUrl">
          <img
            :src="$store.state.fileBaseUrl + editForm.imageUrl"
            alt=""
            style="width: 200px; height: 200px"
          />
        </el-form-item>

        <el-form-item label="打卡时间" prop="createTime">
          {{ editForm.createTime }}
        </el-form-item>

        <el-form-item label="审核状态" prop="status">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">驳回</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          label="驳回原因"
          prop="rejectReason"
          v-show="editForm.status == 2"
        >
          <el-input
            size="small"
            v-model="editForm.rejectReason"
            auto-complete="off"
            placeholder="请输入驳回原因"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="审核详情"
      :visible.sync="detailFormVisible"
      width="40%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        ref="editForm"
      >
        <el-form-item label="打卡任务(ID)" prop="taskId">
          {{ editForm.taskTitle }} ({{ editForm.taskId }})
        </el-form-item>

        <el-form-item label="用户头像">
          <img
            v-if="avatarUrl(editForm.user)"
            :src="avatarUrl(editForm.user)"
            alt=""
            style="width: 80px; height: 80px; border-radius: 50%; object-fit: cover"
          />
          <span v-else>-</span>
        </el-form-item>
        <el-form-item label="小红书账号">
          {{ xhsAccount(editForm.user) }}
        </el-form-item>
        <el-form-item label="小红书昵称">
          {{ xhsName(editForm.user) }}
        </el-form-item>

        <el-form-item label="打卡文本" prop="content">
          {{ editForm.content }}
        </el-form-item>

        <el-form-item label="打卡图片" prop="imageUrl">
          <img
            :src="$store.state.fileBaseUrl + editForm.imageUrl"
            alt=""
            style="width: 200px; height: 200px"
          />
        </el-form-item>

        <el-form-item label="打卡时间" prop="createTime">
          {{ editForm.createTime }}
        </el-form-item>

        <el-form-item label="审核状态" prop="status">
          {{
            editForm.status == 1
              ? "已经通过"
              : editForm.status == 2
              ? "已经驳回"
              : "异常"
          }}
        </el-form-item>

        <el-form-item
          label="驳回原因"
          prop="rejectReason"
          v-show="editForm.status == 2"
        >
          {{ editForm.rejectReason }}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "../../components/Pagination";
import upImg from "../../components/upImg.vue";
import editor from "../../components/editor.vue";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      detailFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        id: "",
        taskId: "",
        taskTitle: "",
        userId: "",
        user: null,
        content: "",
        imageUrl: "",
        createTime: "",
        status: 0,
        rejectReason: "",
      },
      rules: {
        status: [
          { required: true, message: "请选择审核是否通过", trigger: "blur" },
        ],
      },
      listData: [],
      pageparm: {
        pageNum: 1,
        pageSize: 10,
        total: 10,
        status: "",
      },
      options: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "0",
          label: "待审核",
        },
        {
          value: "1",
          label: "已通过",
        },
        {
          value: "2",
          label: "已驳回",
        },
      ],
    };
  },
  // 注册组件
  components: {
    Pagination,
    upImg,
    editor,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.pageparm);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    xhsAccount(user) {
      return (user && user.xhsAccount) || "-";
    },
    xhsName(user) {
      return (user && user.xhsName) || "-";
    },
    avatarUrl(user) {
      if (!user || !user.avatarUrl) return "";
      const a = String(user.avatarUrl).trim();
      if (!a) return "";
      if (/^https?:\/\//i.test(a)) return a;
      const base = this.$store.state.fileBaseUrl;
      if (!base || base === false) return a;
      return String(base).replace(/\/?$/, "/") + a.replace(/^\//, "");
    },
    getdata(parameter) {
      this.loading = true;
      this.$request
        .getCheckinAll(parameter)
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          this.listData = res.data.list;
          // // 分页赋值
          this.pageparm.pageNum = res.data.pageNum;
          this.pageparm.pageSize = res.data.pageSize;
          this.pageparm.total = res.data.total;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageNum = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getdata(this.pageparm);
    },
    // 搜索事件
    search() {
      this.getdata(this.pageparm);
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.title = "审核打卡";
      this.editForm.id = row.id;
      this.editForm.taskId = row.taskId;
      this.editForm.taskTitle = row.taskTitle;
      this.editForm.userId = row.userId;
      this.editForm.user = row.user || null;
      this.editForm.content = row.content;
      this.editForm.imageUrl = row.imageUrl;
      this.editForm.createTime = row.createTime;
      this.editForm.status = row.status;
      this.editForm.rejectReason = row.rejectReason;
    },
     //显示编辑界面
    handleDetail: function (index, row) {
      this.detailFormVisible = true;
      this.editForm.id = row.id;
      this.editForm.taskId = row.taskId;
      this.editForm.taskTitle = row.taskTitle;
      this.editForm.userId = row.userId;
      this.editForm.user = row.user || null;
      this.editForm.content = row.content;
      this.editForm.imageUrl = row.imageUrl;
      this.editForm.createTime = row.createTime;
      this.editForm.status = row.status;
      this.editForm.rejectReason = row.rejectReason;
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      if (this.editForm.status == 0) {
        this.$message({
          type: "error",
          message: "请选择审核状态！",
        });
      }
      this.$refs[editData].validate((valid) => {
        if (valid) {
          this.$request
            .postAudit({
              recordId: this.editForm.id,
              status: this.editForm.status,
              rejectReason: this.editForm.rejectReason,
            })
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              this.getdata(this.pageparm);
              this.$message({
                type: "success",
                message: "保存成功！",
              });
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    // 删除公司
    takenOff(index, row) {
      this.$confirm("确定要下架该商品吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request
          .offlineGoods({ id: row.id })
          .then((res) => {
            this.$message({
              type: "success",
              message: "下架成功!",
            });
            this.getdata(this.pageparm);
          })
          .catch((err) => {
            this.loading = false;
          });
      });
    },
    takenOn(index, row) {
      this.$confirm("确定要重新上架该商品吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(() => {
        this.$request
          .onlineGoods({ id: row.id })
          .then((res) => {
            this.$message({
              type: "success",
              message: "下架成功!",
            });
            this.getdata(this.pageparm);
          })
          .catch((err) => {
            this.loading = false;
          });
      });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.detailFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box {
  display: flex;
}
</style>





// WEBPACK FOOTER //
// src/views/audits/audits.vue